import { render, staticRenderFns } from "./PackagesForm.vue?vue&type=template&id=2061f6c7"
import script from "./PackagesForm.vue?vue&type=script&lang=js"
export * from "./PackagesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports